import { Box, Typography } from "@mui/material";
import {
  backgroundColor01,
  blackColor,
  blackColor26,
  lightBlueColor,
  orangeColor,
  orangeColor01,
  orangeLightColor,
} from "../../configs/styles/muiThemes";

function HowItWorks() {
  return (
    <Box p="15px 10px">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="h6"
          fontSize={10}
          fontWeight={500}
          color={orangeColor01}
          textAlign="center"
          sx={styles.heading}
        >
          HOW IT WORKS ?
        </Typography>

        <Typography
          variant="h3"
          fontSize={14}
          fontWeight={600}
          lineHeight="24px"
          color={blackColor}
          textAlign="center"
          sx={{ m: "5px 0 4px !important" }}
        >
          Sign up, Promote, Earn. It's that Simple
        </Typography>
      </Box>

      <Box
        display={"flex"}
        flexDirection={"column"}
        gap={2}
        m="5px 5px !important"
      >
        <InfoStepCard
          icon="/./assets/images/promoto-1.svg"
          // icon="https://storage.googleapis.com/bodefaults/shopweb/register-as-brand.svg"
          title="Register as a Brand affiliate via CostBo Website OR Android/IOS app"
          description="Get a unique affiliate Code"
        />
        <InfoStepCard
          icon="/./assets/images/promoto-2.svg"
          // icon="https://storage.googleapis.com/bodefaults/shopweb/promote-brands-products.svg"
          title="Promote our products"
          description="Via Whatsapp, Instagram, other Social Media/Blogs/Emails/Community groups etc"
        />
        <InfoStepCard
          icon="/./assets/images/promoto-3.svg"
          // icon="https://storage.googleapis.com/bodefaults/shopweb/earn-commission.svg"
          title="Earn Commission"
          description="Receive commission payment based on customer orders"
        />
      </Box>
    </Box>
  );
}

export default HowItWorks;

const InfoStepCard = ({ icon, title, description }) => {
  return (
    <Box sx={styles.card}>
      <Box
        component="img"
        src={icon}
        sx={{ width: "45px", height: "45px", objectFit: "contain", mb: "6px" }}
      />

      <Box>
        <Typography
          variant="h6"
          fontSize={13}
          fontWeight={600}
          lineHeight="18px"
          textAlign="center"
          color={blackColor}
          mb="2px !important"
        >
          {title}
        </Typography>

        <Typography
          variant="body2"
          fontSize={11}
          fontWeight={400}
          lineHeight="18ter"
          color={blackColor26}
          textAlign="center"
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
};

const styles = {
  heading: {
    textTransform: "uppercase",
    fontWeight: "500",
    background: "#fcefec",
    padding: "1px 20px",
    borderRadius: "50px",
    marginBottom: "4px",
    display: "inline-block",
  },

  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "10px 6px",
    // margin: '15px',
    borderRadius: "8px",
    backgroundColor: backgroundColor01,
  },
};
